import { useEffect } from 'react'

import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import clsx from 'clsx'
import { observer } from 'mobx-react-lite'

import { RoutingPaths } from 'app/routes/routes'

import {
  getCollectionCardItems,
  useSelectCollectionItem,
} from 'features/kyrgyzstan/select-collection-item'

import { kyrgyzstanCollectionsStore } from 'entities/kyrgyzstan/model'
import { CollectionsHorizontalLayout } from 'entities/kyrgyzstan/ui'

import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types'
import { Skeleton } from 'shared/ui/skeleton'

import s from './styles.module.scss'

const SkeletonItemsCount = 1

export const Collections = observer(() => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  useEffect(() => {
    kyrgyzstanCollectionsStore.loadIfNeeded()
  }, [])

  const collections = kyrgyzstanCollectionsStore.getCollections()
  const { isLoading } = kyrgyzstanCollectionsStore
  const { selectCollectionItem } = useSelectCollectionItem()

  if (!isLoading && collections.length === 0) {
    return null
  }

  return (
    <div className={s.sections}>
      {isLoading
        ? Array.from({ length: SkeletonItemsCount }).map((_, index) => (
            <div
              key={index}
              className={s.container}
            >
              <div className={s.header}>
                <Skeleton className={s.skeletonTitle} />
              </div>

              <CollectionsHorizontalLayout
                key={index}
                items={[]}
                isLoading
              />
            </div>
          ))
        : collections.map((collection) => (
            <div
              key={collection.id}
              className={s.container}
            >
              <div className={s.header}>
                <h2 className={clsx(s.title, 'bold-16')}>
                  {collection.title || t('kyrgyzstan_block.collections.title')}
                </h2>

                <button
                  type="button"
                  className={s.viewAll}
                  onClick={() =>
                    navigate(
                      RoutingPaths.kyrgyzstan.collections.path(collection.id),
                    )
                  }
                >
                  <span className="medium-14">
                    {t('kyrgyzstan_block.collections.view_all')}
                  </span>
                  <AppIcon
                    id={AllIcons.CHEVRON_RIGHT}
                    width={12}
                    height={12}
                  />
                </button>
              </div>

              <CollectionsHorizontalLayout
                items={getCollectionCardItems(collection)}
                onSelectItem={(item) => selectCollectionItem(item)}
              />
            </div>
          ))}
    </div>
  )
})
